import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/footer";
import MajorTools from "./MajorTools";
import Authorization from "./Authorization";
import InfoSection from "./InfoSection";
import { Helmet } from "react-helmet-async";



const Integration = () => {
  const location = useLocation();
  const title = "Best AI Testing Tools to Enhance and Boost Software QA";
  const description = "Discover the best ai testing tools to accelerate testing, improve accuracy, and enhance software quality with advanced AI-powered testing automation.";
  return (
    <><Helmet>
  <title>
    {title}
  </title>

  <meta
    name="description"
    content={description}
  />

  <meta
    name="keywords"
    content="best ai testing tools"
  />

  <link
    rel="canonical"
    href="https://frothtestops.com/Integration"
  />

  {/* Open Graph Tags */}
  <meta property="og:title" content={title} />
  <meta property="og:description" content={description} />
  <meta property="og:image" content="/images/og-image.jpg" />
  <meta property="og:type" content="website" />
  <meta property="og:url" content={`https://frothtestops.com${location.pathname}`} />

  {/* Twitter Card Tags */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={title} />
  <meta name="twitter:description" content={description} />
  <meta name="twitter:image" content="/images/og-image.jpg" />
</Helmet>
    <div className={`fd-main-wrapper ${location.pathname !== "/" ? "page-padding" : ""}`}>
      <Header />
        <MajorTools />
        <Authorization />
        <InfoSection />
      <Footer />
    </div>
    </>
  );
};

export default Integration;
